"use strict";
/****************************************************
 * Audit Information Platform Component
 * 常量定义
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECT_DEFUALT_VALUE = exports.UNKNOWN_ERROR_MSG = exports.QUERY_ERROR_MSG = void 0;
/**
 * 常量定义
 */
exports.QUERY_ERROR_MSG = '没有返回数据';
exports.UNKNOWN_ERROR_MSG = '未知错误';
exports.SELECT_DEFUALT_VALUE = "请选择";
